export class TopItemsData {
  data: any = {};
  loading: boolean;
}
